import logo from '@/assets/images/creditpro-logo.png';
import classes from './style.module.css';

const LandingHeader = () => (
  <header className={classes.header}>
    <a
      className={classes.logo}
      href="https://www.creditpro.co.il"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="CreditPro site"
    >
      <img className={classes.logoImage} src={logo} alt="CreditPro" />
    </a>
  </header>
);

export default LandingHeader;
